@if (pagination && totalPages.length > 1) {
  <div [class.pointer-events-none]="isDisabled">
    <ul class="d-flex align-items-center">
      @if (pagination.page !== 1) {
        <li>
          <button
            class="button button--icon-sm button--secondary"
            (click)="loadPage(1)"
          >
            <i class="icon-webcash_double-arrows-left-icon"></i>
          </button>
        </li>
      }


      @if (pagination.page !== 1) {
        <li>
          <button
            class="button button--icon-sm button--secondary"
            (click)="loadPage(pagination.page - 1)"
          >
            <i class="ri-arrow-left-s-line"></i>
          </button>
        </li>
      }

      @for (page of totalPages; track page;) {
        <li>
          @switch (paginationState) {
            @case ('at-first') {
              <div class="d-flex">
                @if (page <= 5 || page > maxPage - 3) {
                  <button
                    class="button button--icon-sm {{ page === pagination.page ? 'button--primary' : 'button--secondary' }}"
                    (click)="loadPage(page)"
                  >
                    {{ page }}
                  </button>
                }

                @if (page === 5 && maxPage > 8) {
                  <button class="button button--icon-sm button--secondary">
                    ...
                  </button>
                }
              </div>
            }

            @case ('in-middle') {
              <div class="d-flex">
                @if (page === 1 || page >= pagination.page - 2 && page <= pagination.page + 2 || page === maxPage) {
                  <button
                    class="button button--icon-sm {{ page === pagination.page ? 'button--primary' : 'button--secondary' }}"
                    (click)="loadPage(page)"
                  >
                    {{ page }}
                  </button>
                }

                @if (page === 2 || page === maxPage - 1  && maxPage > 8) {
                  <button class="button button--icon-sm button--secondary">
                    ...
                  </button>
                }
              </div>
            }

            @case('at-end') {
              <div class="d-flex">
                @if (page <= 3 || page > maxPage - 5) {
                  <button
                    class="button button--icon-sm {{ page === pagination.page ? 'button--primary' : 'button--secondary' }}"
                    (click)="loadPage(page)"
                  >
                    {{ page }}
                  </button>
                }

                @if (page === maxPage - 5  && maxPage > 8) {
                  <button class="button button--icon-sm button--secondary">
                    ...
                  </button>
                }
              </div>
            }

            @default {
              <button
                class="button button--icon-sm {{ page === pagination.page ? 'button--primary' : 'button--secondary' }}"
                (click)="loadPage(page)"
              >
                {{ page }}
              </button>
            }
          }
        </li>
      }

      @if (maxPage !== pagination.page) {
        <li>
          <button
            class="button button--icon-sm button--secondary"
            (click)="loadPage(pagination.page + 1)"
          >
            <i class="ri-arrow-right-s-line"></i>
          </button>
        </li>
      }

      @if (maxPage !== pagination.page) {
        <li>
          <button
            class="button button--icon-sm button--secondary"
            (click)="loadPage(maxPage)"
          >
            <i class="icon-webcash_double-arrows-right-icon"></i>
          </button>
        </li>
      }
    </ul>
  </div>
}
